/**
 * Hebrew guide body paragraphs by topic id.
 * Tab titles stay in guidesHe (translations.js); article text uses this map.
 */
const guidesParagraphsHe = {
  welcome: [
    "Mu Beginning הוא שרת פרטי Season 6 Episode 3 עם משחק MU קלאסי, מערכות מותאמות ופיצ'רים לנוחות.",
    "במדורים האלה תלמדו על מחלקות, ריסטים, VIP, מבוכים, יצירת Fenrir, אירועים ועוד — כל הערכים תואמים לנתוני ה־GameServer החיים.",
    "הצטרפו לדיסקורד להודעות, תמיכה ועזרה מהקהילה.",
  ],

  "game-options": [
    "פתחו את Game Settings מתפריט System / Escape במשחק (Option / Game Settings). כותרת החלון היא “Game Settings”.",
    "ההגדרות נשמרות מקומית תחת Data\\Custom\\GameOption\\GameOption.xml ונשארות גם אחרי הפעלה מחדש של הקליינט.",
    "יש שתי לשוניות עיקריות: Game ו־Graphics. בהן שולטים בעזרי קרב, תצוגת ממשק, ביצועים, רזולוציה, FPS, סאונד ומה מוצג על המסך.",
    "טיפ: אם המשחק מרגיש איטי במפות עמוסות או באירועים — הורידו Graphics Mode, הפחיתו FPS, או הפעילו Hide (שחקנים/מפלצות/כנפיים) לשיפור ביצועים.",
  ],

  "game-options-game-tab": [
    "Drop Item / Show Name Item — בחרו “Always Show item Names” או “Do Not Show”. כשמופעל Always Show, שמות פריטים על הקרקע נשארים גלויים בלי לעבור עליהם.",
    "Auto HP — Turn On / Turn Off. כשמופעל, הקליינט מבקש מהשרת התנהגות של השבת HP אוטומטית (שימושי בציד).",
    "Auto Attack — Turn On / Turn Off. מפעיל עזרת תקיפה אוטומטית / סגנון Auto-PK. השתמשו בזהירות ושמרו על חוקי השרת.",
    "Show HP Bar — Always Show או Do Not Show. שולט אם מוצגות פסי HP מעל דמויות/מפלצות.",
    "Show Character Name — Always Show או Do Not Show. שולט אם שמות הדמויות נשארים גלויים על המסך.",
    "VSync — נועל את הצגת הפריימים לקצב הרענון של המסך כדי להפחית tearing (עלול להוריד FPS במחשבים חלשים).",
    "Effect 15 — מדליק/מכבה שכבת אפקט ויזואלי נוספת (אפשר לכבות לביצועים).",
    "Screen Camera — מדליק/מכבה מצב מצלמה מותאם אישית שלנו.",
  ],

  "game-options-graphics-tab": [
    "Mode Graphics — מצבים: Low, Medium, High, Ultra. שינוי המצב מתאים אוטומטית צללים, זוהר, אפקטי Excellent ודגלי איכות קשורים.",
    "FPS Limit — בחרו 60 / 120 / 144 / 175 / 200 / Unlimited. FPS גבוה יותר חלק יותר אבל דורש מחשב חזק יותר. Unlimited מסיר את התקרה הרכה.",
    "Option Game (הסתרת רינדור) — Hide Wings, Hide Weapon, Hide Texture, Hide Monster, Hide Terrain, Hide Player. מפשט את מה שמצויר ומשפר FPS במלחמות/אירועים.",
    "On/Off Music — הפעלה/כיבוי מוזיקת רקע. סליידר Music Volume (0–100) שולט בעוצמה כשהמוזיקה פועלת.",
    "On/Off World Sound — הפעלה/כיבוי צלילי עולם/סביבה (מכות מפלצות, אווירת מפה וכו').",
    "Resolution — בחרו רזולוציה מהרשימה (גללו אם צריך). הקליינט מחיל את הגודל החדש ומרענן את הממשק.",
    "Font Size — גודל גופן 13 / 14 / 15. גופן גדול יותר עוזר לקריאות במסכים ברזולוציה גבוהה.",
    "מומלץ: התחילו עם High + 60/120 FPS; אם נופלים פריימים ב־Castle Siege או פלישות — עברו ל־Medium/Low והסתירו שחקנים/מפלצות אחרים.",
  ],

  helper: [
    "ה־MU Helper מסייע בציד אוטומטי, שיקויים והגדרות איסוף.",
    "הגדירו בזהירות ושמרו על חוקי משחק הוגן — שימוש לרעה עלול להוביל לעונשים.",
    "אפשרויות המשחק (Auto Attack / Auto HP) עובדות יחד עם הגדרות ה־Helper — בדקו את שתיהן כדי שהדמות תתנהג כמצופה.",
  ],

  interface: [
    "השתמשו באינבנטורי, מחסן, פארטי, קווסטים וחלון Event Time כדי לשחק ביעילות.",
    "פתחו Event Time במשחק לראות ספירות לאחור ל־Blood Castle, פלישות ועוד — פאנל Upcoming Events באתר משתמש באותם לוחות זמנים.",
    "לחצן Push-to-talk לצ'אט קולי הוא F1 (ראו Systems → Voice Chat). Game Settings מטפל בגרפיקה/סאונד/ממשק; קיצורי מקשים כמו F1 נפרדים.",
  ],

  dw: [
    "מחלקת קסם לטווח. סטאט הנזק העיקרי הוא Energy; Vitality לשרידות.",
    "חזקה בגלים של PvE ובתוכן פארטי עם כישורי AoE. שימו דגש על מיקום וניהול מאנה.",
    "מסלול ההתפתחות כולל Soul Master ו־Grand Master (Season 6).",
  ],

  dk: [
    "לוחם קרוב לחזית. Strength לנזק, Agility למהירות התקפה/הגנה, Vitality ל־HP.",
    "מצוין ל־PvP ולטנקינג באירועים כמו Blood Castle ו־Chaos Castle.",
    "מתפתח דרך Blade Knight ו־Blade Master.",
  ],

  fe: [
    "היברידית תמיכה ו־DPS לטווח. בילד Agility לנזק קשת; Energy לריפוי/באפים.",
    "מאוד מוערכת בפארטי בזכות באפים וקיימות. חזקה ב־PvE ובתפקידי תמיכה ב־Castle Siege.",
    "מתפתחת דרך Muse Elf ו־High Elf.",
  ],

  mg: [
    "היבריד לוחם־קוסם. יכול להשתמש בחרבות ובקסם; לרוב היברידי Strength/Energy.",
    "גמיש לקרב קרוב ולקסמים לטווח. אול־ראונדר חזק לאירועים ולפארם.",
    "לא עובר את אותו מסלול קווסט 2nd/3rd כמו מחלקות ההתחלה — בדקו מדריכי קווסט במשחק.",
  ],

  dl: [
    "מחלקה מבוססת Command עם חיות מחמד וכישורי מנהיגות פארטי. Leadership (Command) הוא סטאט מרכזי.",
    "חזק ב־PvP ובקרבות גדולים. משתמש ב־Dark Horse / Dark Raven ובסטים מיוחדים ל־DL.",
    "דורש השקעה נכונה ב־Leadership ליעילות הכישורים.",
  ],

  su: [
    "מחלקת זימון קסם עם קללות, ספרים וחיות זימון. Energy הוא סטאט הנזק העיקרי.",
    "מצטיין בשליטה לטווח בינוני/ארוך וב־PvE. למדו כישורי ספרים וניהול זימונים מוקדם.",
    "מתפתח דרך Bloody Summoner ו־Dimension Master.",
  ],

  rf: [
    "אמן לחימה לטווח קרוב עם כפפות וכישורי RF מיוחדים. Strength ו־Vitality הם הליבה.",
    "פרץ גבוה וניידות ב־PvP; פארם חזק כשיש גיר.",
    "מתפתח דרך Fist Master. אין Grow Lancer (GL) בשרת הזה.",
  ],

  // Full HE content for Systems topics lives in guideSystemsContent.js
  "battle-pass": [],

  // Full HE content for Dungeon System is in guideSpecialContent.js
  dungeons: [],

  vip: [],

  "fenrir-mix": [],

  // Full HE content for Reset System is in guideSpecialContent.js
  reset: [],

  "grand-reset": [],

  voice: [],

  quests: [],

  market: [],

  "expanded-inventory": [],

  "online-bonus": [],

  spots: [
    "התחילו במפות ההתחלה Lorencia / Noria / Devias, ואז עברו למפות גבוהות יותר כשהרמה והגיר משתפרים.",
    "השתמשו בציד פארטי, Online Bonus, VIP EXP ומבוכים כדי להאיץ ריסטים מוקדמים.",
    "Kanturu Dungeon חשוב בהמשך לחומרי Fenrir; מבוכי Chaos/Devil Square עוזרים להכנסת תכשיטים.",
  ],

  progression: [
    "1) הגיעו לרמה 400 והתחילו ריסטים · 2) פתחו VIP אם אתם משחקים יומיומית · 3) השתמשו במבוכים ל־EXP/תכשיטים · 4) טפסו ל־50 ריסטים · 5) Grand Reset לבוסט נקודות גדול · 6) צרו Fenrir כשהחומרים מוכנים.",
    "בדקו Commands ו־Event Time באופן קבוע כדי לא לפספס חלונות תגמול חינמיים.",
  ],

  // Full HE content for Events lives in guideEventsContent.js
  "blood-castle": [],
  "devil-square": [],
  "chaos-castle": [],
  illusion: [],
  imperial: [],
  kanturu: [],
  kalima: [],
  invasions: [],
  "boss-together": [],
  "arka-war": [],
  "double-goer": [],
  "castle-siege": [],
  crywolf: [],
  "castle-deep": [],
  "moss-merchant": [],
  tvt: [],
  "other-events": [],
  "wings-1": [],
  "wings-2": [],
  "wings-3": [],
  "class-1": [],
  "class-2": [],
  "class-3": [],
};

export default guidesParagraphsHe;
